import { mapState } from 'vuex';
import tinkoff from './tinkoff/index.vue';

import f from '@/application/shared/functions.js'

const ct = require("countries-and-timezones");


export default {
    name: 'setpayment',
    props: {
       
        plan : Object,

    },

    components : {
        tinkoff
    },

    data : function(){

        return {
            loading : true,
            selectedPeriod : null,
            identity : null,
            promocode : '',
            promoresult : null,
            promoerror : null,
        }

    },

    created(){
        this.selectedPeriod = _.min(this.price, (p) => {
            return p.p
        })
    },

    watch: {
        selectedPeriod : {
            immediate : true,
            handler : function(){
                this.loadIdentity()
            }
        },

        promocode : function(){
            if (this.promocode){
                this.core.api.payments.checkpromo({code : this.promocode, planid : this.plan.id}).then(promoresult => {
                    this.promoresult = promoresult
                    this.promoerror = null
                }).catch(e => {
                    this.promoerror = e
                    this.promoresult = null
                })
            }
            else{
                this.promoerror = null
                this.promoresult = null
            }
        }
    },
    computed: mapState({
        auth : state => state.auth,

        price : function(){
            return _.filter(this.plan.price, (p) => {
                return !p.hidden
            })
        },

        country : function(){
            var tzc = ct.getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);

            return tzc?.id
        },

        type : function(){

            if(window.cordova && f.isios()){
                return 'inapppurchase'
            }

            if(this.country == 'RU'){
                return 'tinkoff'
            }
            
            return null
        },

        currency : function(){
            return 'rub'
        },

        description : function(){
            return this.$t('plans.' + this.plan.name + '.name')
        },

        customer : function(){
            if(this.identity) return this.identity.split(':')[0]
        },

        info : function(){
            return {
                identity : this.identity,
                code : this.promoresult ? this.promoresult.code : ''
            }
        },

        locale : function(state){
            return state.locale
        },

        ref : function(){
            return ""
        }
    }),

    methods : {
        valueWithPromo : function(value){
            if(this.promoresult){
                value = Number((value * (100 - (this.promoresult.feature?.discount || 0)) / 100).toFixed(0))
            }
            
            
            return value
        },
        selectPeriod : function(p){
            this.selectedPeriod = p
        },
        checkpromo : function(){

        },
        loadIdentity : function(){

            this.identity = null

            if(!this.selectedPeriod) return

            this.loading = true

            this.core.api.payments.identity({
                planid : this.plan.id,
                period : this.selectedPeriod.p
            }).then((i) => {
                this.identity = i

            }).catch(e => {
                console.error(e)
            }).finally(() => {
                this.loading = false
            })
        },

        inputPromoCode : function(e){
            this.promocode = e.target.value
        },

        privacy : function(){
            this.core.vueapi.privacy()
        },

        terms : function(){
            this.core.vueapi.terms()
        }
    },
}